// import trust_edge_logo from "assets/images/TE_logo.webp";
import trust_edge_logo from "../Footer/assets/trust_edge_footer_logo.webp";
import iitb_banner_new from "assets/images/iitb_banner.webp";



import certificate_banner from "assets/images/new_certificate_banner.webp";
import mobile_certificate_banner from "assets/images/mobile_certificate_banner.webp";
// import educationpostlogo from "assets/news/education-post-logo.webp"

import hindustan_times_logo from "assets/news/hindustan-times-logo.webp"
import timesofindia_logo from "assets/news/the-times-of-india-logo.webp"
import india_today_logo from "assets/news/india-today.webp"
import the_hindu_logo from "assets/news/the-hindu-newspaper-logo.webp"
import indian_startup_times_logo from 'assets/news/indian_startup_times_logo.webp';
import careers_360 from "assets/news/careers_360.webp"
import shiksha_logo from "assets/news/shiksha.webp"
import certificate_slide_1 from "assets/images/certificate_slide_1.jpeg";
import certificate_slide_2 from "assets/images/certificate_slide_2.jpeg";
import certificate_slide_3 from "assets/images/certificate_slide_3.jpeg";

// import "./trustEdgeLanding.css";

import { Container, Row, Image, Col, Modal } from "react-bootstrap";
import { useMediaQuery } from 'react-responsive';
import { courses } from "Constants/courses";
import CourseCard from "Screens_old/CourseCard/CourseCard";
import FooterTrust from "Screens_old/Footer/FooterTrust";
import ReviewSlider from "Screens_old/ReviewSlider/ReviewSlider";
import { cohorts, stepsToAdoptBodhitree } from "./data";
import { classNames } from "Store/utils";
import trustEdgeStyles from "TrustEdge.module.css";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";


const TrustEdgeLanding = (props) => {
    const location = useLocation();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const upcomingCourse = courses.find((c) => c.id === 7);
    const [selectedCohort, setSelectedCohort] = useState(null);

    const allReviews = courses
        .map((course) => {
            const courseReviews = course.reviews || [];
            return [...courseReviews];
        })
        .flat();

    // Press coverage data with images
    const pressCoverage = [
        {
            outlet: "The Hindu",
            title: "IIT Bombay invites applications for advanced programmes in cybersecurity and software development",
            url: "https://www.thehindu.com/news/cities/mumbai/iit-bombay-invites-applications-for-advanced-programmes-in-cybersecurity-and-software-development/article70267277.ece",
            image: the_hindu_logo,
            date: "November 12, 2025"
        },
        {
            outlet: "Shiksha",
            title: "IIT Bombay Announces Second Series of Professional Certification Courses in Cybersecurity and Software Development",
            url: "https://www.shiksha.com/university/iit-bombay-indian-institute-of-technology-mumbai-54212/news-articles",
            image: shiksha_logo,
            date: "November 14, 2025"
        },
        {
            outlet: "Careers360",
            title: "IIT Bombay launches online certificate courses in cybersecurity, software development",
            url: "https://news.careers360.com/iit-bombay-launches-online-certificate-courses-in-cybersecurity-software-development-trustedge-iitb-ac-in",
            image: careers_360, 
            date: "November 8, 2025"
        },
        {
            outlet: "Indian Startup Times",
            title: "IIT Bombay announces second series of professional certification courses in cybersecurity and software development",
            url: "https://www.indianstartuptimes.com/news/iit-bombay-announces-second-series-of-professional-certification-courses-in-cybersecurity-and-software-development/",
            image: indian_startup_times_logo,
            date: "November 8, 2025"
        },
        {
            outlet: "The Hindu",
            title: "IIT Bombay launches professional certificate programs in cybersecurity and software development",
            url: "https://www.thehindu.com/education/colleges/iit-bombay-launches-professional-certificate-programs-in-cybersecurity-and-software-development/article69837777.ece",
            image: the_hindu_logo,
            date: "July 21, 2025"
        },
        {
            outlet: "Times of India",
            title: "IIT Bombay launches certificate programmes in cybersecurity and software development",
            url: "https://timesofindia.indiatimes.com/education/news/iit-bombay-launches-certificate-programmes-in-cybersecurity-and-software-development-check-how-to-apply/articleshow/122815130.cms",
            image: timesofindia_logo,
            date: "July 21, 2025"
        },
        {
            outlet: "Hindustan Times",
            title: "IIT Bombay launches professional certificate programs in cybersecurity, software development",
            url: "https://www.hindustantimes.com/education/iit-bombay-launches-professional-certificate-programs-in-cybersecurity-software-development-101753087663319.html",
            image: hindustan_times_logo,
            date: "July 21, 2025"
        },
        
        {
            outlet: "India Today",
            title: "IIT Bombay introduces one-year online certificate programmes in cybersecurity and software development",
            url: "https://bestcolleges.indiatoday.in/news-detail/iit-bombay-introduces-one-year-online-certificate-programmes-in-cybersecurity-and-software-development-4610",
            image: india_today_logo,
            date: "July 21, 2025"
        },
    ];



    // {
    //     outlet: "Education Post",
    //     title: "IIT Bombay introduces online certification programs in cybersecurity and software development",
    //     url: "https://educationpost.in/news/education/iit-bombay-introduces-online-certification-programs-in-cybersecurity-and-software-development",
    //     image: educationpostlogo
    //   }

    useEffect(() => {
        // Handle scroll from navigation state
        if (location.state?.scrollTo) {
            const element = document.getElementById(location.state.scrollTo);
            if (element) {
                setTimeout(() => {
                    const yOffset = -80; // Adjust this value based on your header height
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }, 100);
            }
        }

        // Handle scroll from URL hash
        if (location.hash) {
            const elementId = location.hash.substring(1);
            const element = document.getElementById(elementId);
            if (element) {
                setTimeout(() => {
                    const yOffset = -80; // Adjust this value based on your header height
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }, 100);
            }
        }
    }, [location]);

    return (
        <>
            <Container
                fluid
                className={classNames("pl-0 pr-0", trustEdgeStyles['landingImageParent'])}
            // style={{ userSelect: "none" }}
            >
                <Row className="ml-0 mr-0">
                    <Col
                        md={5}
                        className="d-flex flex-column justify-content-center"
                    >
                        <div className="row">
                            <Col
                                xs={12}
                                md={12}
                                className="pt-2 pl-md-5 pr-md-5 d-flex justify-content-start"
                            >
                                <Image
                                    width={`400px`}
                                    src={trust_edge_logo}
                                    alt="IITB logo"
                                    style={{ background: "white" }}
                                    className="img-fluid p-2"
                                />
                            </Col>
                            <Col
                                xs={12}
                                md={12}
                                className="pl-md-5 pr-md-5 pt-4 text-white text-left"
                            >
                                <p className="p-0 m-0 trustedge_size48 d-none d-md-block font-weight-bold">
                                    Quality
                                    <span style={{ color: "#FFC24A" }}> Hands-on </span>
                                </p>
                                <p className="trustedge_size48 d-none d-md-block font-weight-bold">Technical Education</p>

                                {/* Mobile version with smaller font */}
                                <p className="p-0 m-0 trustedge_size41 d-block d-md-none font-weight-bold">
                                    Quality
                                    <span style={{ color: "#FFC24A" }}> Hands-on </span>
                                </p>
                                <p className="trustedge_size41 d-block d-md-none font-weight-bold">Technical Education</p>
                            </Col>
                        </div>
                    </Col>
                    <Col md={7} className="pl-0 pr-0">
                        <Image
                            className="iitb_banner w-100"
                            src={iitb_banner_new}
                            style={{ objectFit: "cover" }}
                        />
                    </Col>
                </Row>
            </Container>

            {/* Upcoming Course Section */}
            {upcomingCourse && (
                <Container
                    id="upcoming-course"
                    fluid
                    className={classNames(trustEdgeStyles['container-width'], "pt-2 pb-2 mt-3 d-flex justify-content-center courses-section")}
                >
                    <div className="py-4 w-100">
                        <Row>
                            <Col xs={12}>
                                <h2 className="px-4">Upcoming Course</h2>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6} xl={4} xxl={3} className="mb-0 mb-md-3 d-flex justify-content-center">
                                <div style={{ width: "100%", maxWidth: "350px", minWidth: "280px", display: "flex", flexDirection: "column" }}>
                                    <CourseCard
                                        id={upcomingCourse.id}
                                        course_img={upcomingCourse.image}
                                        course_title={upcomingCourse.program_title}
                                        program_start_date={upcomingCourse.program_start_date}
                                        duration={upcomingCourse.duration}
                                        category={upcomingCourse.category}
                                        program_type={upcomingCourse.program_type}
                                        parent_program_ids={upcomingCourse.parent_program_ids}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            )}

            {/* Our Unique Value Proposition Section */}
            <Container
                id="why-us"
                className="container-fluid pt-0 pt-md-3 pl-0 pr-0 d-flex flex-column justify-content-center align-items-center"
                style={{ minHeight: "50vh" }}
            >
                <Container className={classNames(trustEdgeStyles['container-width'])}>
                    <h2
                        className="size24 text-center text-md-left pl-0 py-md-2 pb-2 pt-1"
                        style={{ fontWeight: "bold" }}
                    >
                        Our Unique Value Proposition: Why learn from us?
                    </h2>
                    <Row className="d-flex justify-content-center">
                        {stepsToAdoptBodhitree.map((step, i) => {
                            return (
                                <Col
                                    key={`${i}_step`}
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    className="d-flex justify-content-center"
                                >
                                    <div
                                        className="d-flex flex-column justify-content-start align-items-start  h-100"
                                        style={{ paddingLeft: "8px", width: "100%" }}
                                    >
                                        <Image
                                            src={step.image}
                                            className="my-2"
                                            alt="Feature Icon"
                                        />
                                        <p
                                            className="trustedge_size18 font-weight-bold"
                                            style={{ color: "#000", minHeight: "48px", display: "flex", alignItems: "flex-start" }}
                                        >
                                            {step.title}
                                        </p>
                                        <p
                                            className={classNames("pl-0", trustEdgeStyles['size16'], "font-weight-normal text-left")}
                                            style={{ color: "#757589" }}
                                        >
                                            {step.desc}
                                        </p>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                    <Row>
                        <Col sm={12} className="pb-5">
                            <Image
                                className="w-100"
                                src={isMobile ? mobile_certificate_banner : certificate_banner}
                                style={{ borderRadius: "10px" }}
                                alt="Certificate Banner"
                            />
                        </Col>
                    </Row>
                </Container>
                <Container
                    fluid
                    className={classNames(trustEdgeStyles['container-width'], "pt-2 pb-2 d-flex justify-content-center courses-section")}
                    style={{ minHeight: "100vh" }}
                >
                    <div className="py-4 w-100">
                        <Row className="">
                            {/* Programs Section */}
                            <Col id="programs-we-offer" xs={12}>
                                <h2 className="px-4">Programs we offer</h2>
                            </Col>

                            {/* Programs Cards */}
                            {courses
                                .filter((item) => item.category === "Professional Certificate" && item.id !== 1)
                                .map((item) => {
                                    return (
                                        <Col
                                            key={item.id}
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={6}
                                            xl={4}
                                            xxl={3}
                                            className="mb-0 mb-md-3 d-flex justify-content-center"
                                        >
                                            <div style={{
                                                width: "100%",
                                                maxWidth: "350px",
                                                minWidth: "280px",
                                                display: "flex",
                                                flexDirection: "column"
                                            }}>
                                                <CourseCard
                                                    id={item.id}
                                                    course_img={item.image}
                                                    course_title={item.program_title}
                                                    program_start_date={item.program_start_date}
                                                    duration={item.duration}
                                                    category={item.category}
                                                    program_type={item.program_type}
                                                    parent_program_ids={item.parent_program_ids}
                                                />
                                            </div>
                                        </Col>
                                    );
                                })}

                            {/* Courses Section */}
                            <Col id="courses-we-offer" xs={12} className="w-100">
                                <h2 className="px-4">Courses we offer</h2>
                            </Col>

                            {/* Courses Cards - ordered by display preference */}
                            {[7, 8, 5]
                                .map((id) => courses.find((c) => c.id === id))
                                .filter((item) => item && item.category !== "Professional Certificate")
                                .map((item) => {
                                    return (
                                        <Col
                                            key={item.id}
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={6}
                                            xl={4}
                                            xxl={3}
                                            className="mb-0 mb-md-3 d-flex justify-content-center"

                                        >
                                            <div style={{
                                                width: "100%",
                                                maxWidth: "350px",
                                                minWidth: "280px",
                                                display: "flex",
                                                flexDirection: "column"
                                            }}>
                                                <CourseCard
                                                    id={item.id}
                                                    course_img={item.image}
                                                    course_title={item.program_title}
                                                    program_start_date={item.program_start_date}
                                                    duration={item.duration}
                                                    category={item.category}
                                                    program_type={item.program_type}
                                                    parent_program_ids={item.parent_program_ids}
                                                />
                                            </div>
                                        </Col>
                                    );
                                })}
                        </Row>
                    </div>
                </Container>
            </Container>

            {/* First Cohort Section */}
            <Container id="first-cohort" fluid className={classNames(trustEdgeStyles['container-width'], "py-4 py-md-5")}>
                <Container className="py-4 py-md-5" style={{ backgroundColor: "#f2f5fa" }}>
                    <Row className="g-4">
                        <Col xs={12} className="text-center mb-2 mb-md-4">
                            <h2 className="px-4">A Year of Cybersecurity Learning</h2>
                            <h5 className="trustedge_weight-600 px-4 mt-3">One Cohort. Three Courses. One Cybersecurity Journey.</h5>
                            <p className={classNames(trustEdgeStyles['size16'], "text-muted px-4 mb-0")}>
                                We’re proud to announce the completion of our first cohort of the IIT Bombay Professional Certification Programme in Cybersecurity.
                            </p>
                        </Col>
                        {cohorts.map((cohort) => (
                            <Col key={cohort.title} xs={12} md={6} xl={4} className="d-flex justify-content-center">
                                <div
                                    className="shadow border rounded bg-white h-100 d-flex flex-column"
                                    style={{ width: "100%", maxWidth: "380px", overflow: "hidden" }}
                                >
                                    <img
                                        src={cohort.image}
                                        alt={`${cohort.title} cohort`}
                                        className="w-100"
                                        style={{ height: "220px", objectFit: "cover", cursor: "zoom-in" }}
                                        onClick={() => setSelectedCohort(cohort)}
                                    />
                                    <div className="p-3">
                                        <h5 className="trustedge_size18 trustedge_weight-600 mb-2">{cohort.title}</h5>
                                        <p className={classNames(trustEdgeStyles['size16'], "text-muted mb-0")}>
                                            {cohort.description}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </Container>

            {/* Press Coverage Section */}
            {/*
            <Container id="press-coverage" fluid className={classNames(trustEdgeStyles['container-width'], "py-4 py-md-5")}>
                <Container className="py-5" style={{ backgroundColor: "#f2f5fa" }}>
                    <Row>
                        <Col xs={12} className="text-center mb-4">
                            <h2 className="px-4">Press Coverage</h2>
                        </Col>
                    </Row>

                    <Row className="d-flex justify-content-center">
                        {pressCoverage.map((article, index) => (
                            <Col
                                key={index}
                                xs={12}
                                sm={6}
                                md={6}
                                lg={3}
                                className="d-flex justify-content-center mb-4"
                            >
                                <div
                                    className="h-100 w-100 p-3"
                                    style={{
                                        maxWidth: "300px",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                        cursor: "pointer"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-4px)";
                                        e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.15)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.1)";
                                    }}
                                    onClick={() => window.open(article.url, '_blank', 'noopener,noreferrer')}
                                >
                                    <div className="d-flex flex-column h-100">
                                        <div className="d-flex flex-column align-items-start mb-3 text-center">
                                            <div
                                                style={{
                                                    width: "100%",
                                                    height: "150px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "6px",
                                                    border: "1px solid #f0f0f0",
                                                    padding: "6px",
                                                    backgroundColor: "#f8f8f8",
                                                    marginBottom: "12px"
                                                }}
                                            >
                                                <Image
                                                    src={article.image}
                                                    alt={`${article.outlet} logo`}
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                    }}
                                                />
                                            </div>
                                            <h5
                                                className="font-weight-bold mb-1"
                                                style={{
                                                    color: "#007bff",
                                                    fontSize: "18px",
                                                    lineHeight: "1.3"
                                                }}
                                            >
                                                {article.outlet}
                                            </h5>
                                            <p
                                                className="text-muted mb-0"
                                                style={{ fontSize: "13px" }}
                                            >
                                                {article.date}
                                            </p>
                                        </div>

                                        <p
                                            className="mb-0 flex-grow-1 text-left"
                                            style={{
                                                color: "#333",
                                                fontSize: "15px",
                                                lineHeight: "1.4",
                                                fontWeight: "400",
                                                display: "-webkit-box",
                                                WebkitLineClamp: "3",
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden"
                                            }}
                                        >
                                            {article.title}
                                        </p>

                                        <div className="mt-3 d-flex align-items-center justify-content-start">
                                            <span
                                                style={{
                                                    color: "#007bff",
                                                    fontSize: "14px",
                                                    fontWeight: "500"
                                                }}
                                            >
                                                Read Article →
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </Container>
            */}


            {/* Insights from Learners Section */}
            {/* <Container fluid className="py-3 py-md-5 mb-3 mb-md-5 pb-3 pb-md-5"> */}
            <Container id="testimonials" className="mb-5">
                <h2 className="py-2 pb-md-5 py-md-4 px-2 px-md-4 text-center fs-4 fs-md-2">
                    Insights from Our Learners
                </h2>
                <div className="mb-3 mb-md-5">
                    <ReviewSlider reviews={allReviews} />
                </div>
            </Container>

            <FooterTrust />

            {/* Cohort photo pop-up */}
            <Modal
                show={!!selectedCohort}
                onHide={() => setSelectedCohort(null)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className="trustedge_size18 trustedge_weight-600">
                        {selectedCohort?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-2 text-center">
                    {selectedCohort && (
                        <img
                            src={selectedCohort.image}
                            alt={`${selectedCohort.title} cohort`}
                            style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default TrustEdgeLanding;
